import React from 'react'
import Link from 'next/link'
import { Grid } from 'semantic-ui-react'

import MainInfo from '../common/MainInfo'

import { mergeStyles } from '@enlyt/base'

import { defaultStyles } from './styles'

export const Account = ({ style }) => {
  const styles = mergeStyles(defaultStyles, style)

  return (
    <Grid>
      <Grid.Column mobile={12} tablet={13} computer={13} largeScreen={13} widescreen={13} style={styles.leftContainer}>
        <MainInfo
          iconName={'user'}
          title={'Account'}
          text={'View contact information, insurance coverage and more'}
        />
      </Grid.Column>
      <Grid.Column
        mobile={4}
        tablet={3}
        computer={3}
        largeScreen={3}
        widescreen={3}
        style={styles.rightContainer}
      >
        <span style={styles.link}>
          <Link href='/account'>View &gt;</Link>
        </span>
      </Grid.Column>
    </Grid>
  )
}
